import { z } from 'zod';

const mediaSchema = z.object({
  link: z.string(),
  caption: z.string().optional(),
});

const imediaSchema = z
  .object({
    id: z.string(),
  })
  .or(
    z
      .object({
        link: z.string(),
        provider: z.object({
          name: z.string(),
        }),
      })
      .or(mediaSchema)
  );

const headerSchema = z
  .object({
    type: z.literal('image'),
    image: imediaSchema,
  })
  .or(
    z.object({
      type: z.literal('video'),
      video: imediaSchema,
    })
  )
  .or(
    z.object({
      type: z.literal('text'),
      text: z.string(),
    })
  )
  .or(
    z.object({
      type: z.literal('document'),
      document: imediaSchema,
    })
  );

const bodySchema = z.object({
  type: z.literal('text').optional(),
  text: z.string(),
});

const flowActionParameterSchema = z.object({
  flow_message_version: z.string(),
  flow_token: z.string(),
  flow_id: z.string(),
  flow_cta: z.string(),
  flow_action: z.string(),
  flow_action_payload: z
    .object({
      screen: z.string(),
    })
    .optional(),
});

export const flowActionSchema = z.object({
  name: z.string(),
  parameters: flowActionParameterSchema,
});

export const buttonsActionSchema = z.object({
  buttons: z.array(
    z.object({
      type: z.literal('reply'),
      reply: z.object({ id: z.string(), title: z.string() }),
    })
  ),
});

const rowSchema = z.object({
  title: z.string(),
  description: z.string(),
  id: z.string(),
});

const sectionSchema = z.object({
  rows: z.array(rowSchema),
  title: z.string().optional(),
});

export const listActionSchema = z.object({
  button: z.string(),
  sections: z.array(sectionSchema),
});

const parametersSchema = z.object({
  display_text: z.string(),
  url: z.string(),
});

export const ctaUrlSchema = z.object({
  name: z.string(),
  parameters: parametersSchema,
});

export const locationActionSchema = z.object({
  name: z.literal('send_location'),
});

const actionSchema = flowActionSchema
  .or(buttonsActionSchema)
  .or(listActionSchema)
  .or(ctaUrlSchema)
  .or(locationActionSchema);

const footerSchema = z.object({
  text: z.string(),
});

const baseInteractiveSchema = z.object({
  action: actionSchema,
  footer: footerSchema.optional(),
});

export const interactiveSchema = baseInteractiveSchema.extend({
  type: z.union([
    z.literal('button'),
    z.literal('flow'),
    z.literal('list'),
    z.literal('cta_url'),
    z.literal('location_request_message'),
  ]),
  header: headerSchema.optional(),
  body: bodySchema,
});
